import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import useSiteCopySelector from 'components/useSiteCopySelector';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import { shouldShowNewResourceLabel } from './utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 18,
    borderRadius: 999,
    backgroundColor: '#17632E',
    color:
      (theme.palette &&
        theme.palette.text &&
        (theme.palette.text.white || theme.palette.text.primary)) ||
      '#FFFFFF',
    fontWeight: 600,
    fontSize: 10,
    lineHeight: '16px',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
}));

const NewResourceLabel = ({ resource, type, className }) => {
  const classes = useStyles();
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  const [featuresSiteConfig] = useSiteConfigSelector(['Features']);

  if (!resource) return null;

  const resourceType =
    type ||
    _get(resource, 'fields.type') ||
    _get(resource, 'fields.mediaType') ||
    _get(resource, 'type');

  const shouldShow = shouldShowNewResourceLabel({
    resource,
    resourceType,
    featuresSiteConfig,
  });

  if (!shouldShow) return null;

  const text = _get(resourceItemPageSiteCopy, 'pageCopy.newLabel', 'New');

  return <span className={_classNames(classes.root, className)}>{text}</span>;
};

NewResourceLabel.propTypes = {
  resource: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
};

NewResourceLabel.defaultProps = {
  resource: null,
  type: undefined,
  className: undefined,
};

export default NewResourceLabel;
